import React from 'react';

const PrismLines = ({
  outerRadius,
  width,
  startPrismWidthPrisms,
  prismGapWidthPrisms,
}) => (
  <g />
);

export default PrismLines;



// WEBPACK FOOTER //
// ./src/PrismLines.js